/* eslint-disable react-refresh/only-export-components */
import { createFileRoute } from '@tanstack/react-router';
import { fetchOutgoingTransactionTracing } from '@/api/transactions';
import { FiberTracingTab } from '@/app/(client)/transactions/-components/FiberTracingTab';
import {
  tracingKeys,
  useOutgoingTransactionTracing,
} from '@/app/(client)/transactions/-hooks/useOutgoingTransactionTracing';
import { Skeleton } from '@/components/ui/skeleton';
import { queryClient } from '@/lib/utils/queryClient';

export const Route = createFileRoute(
  '/(client)/transactions/(pages)/(detail)/outgoing/$txId/tracing',
)({
  loader: ({ params }) =>
    queryClient.ensureQueryData({
      queryKey: tracingKeys.detail(params.txId),
      queryFn: () => fetchOutgoingTransactionTracing(params.txId),
    }),
  component: OutgoingTransactionTracingTab,
});

function OutgoingTransactionTracingTab() {
  const { txId } = Route.useParams();
  const { data: tracing, isLoading } = useOutgoingTransactionTracing(txId);

  if (isLoading) {
    return (
      <div className='flex flex-col gap-4'>
        <Skeleton className='h-8 w-40' />
        <Skeleton className='w-full rounded-xl h-[calc(100vh-340px)] min-h-100' />
      </div>
    );
  }

  if (!tracing) return null;

  return <FiberTracingTab tracing={tracing} />;
}
